module.exports = __webpack_public_path__ + "img/P9220025.bf291f0e.jpg";